import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { FC } from "react";

type ConfirmationModalProps = {
  isOpen: boolean;
  confirmQuestion: string;
  confirmButtonLabel: string;
  handleClose: () => void;
  handleConfirm: () => void;
  confirmTitle?: string;
  cancelTitle?: string;
  isCancelButton?: boolean;
};

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  confirmQuestion,
  confirmButtonLabel,
  handleClose,
  handleConfirm,
  confirmTitle,
  cancelTitle,
  isCancelButton,
}) => {
  const handleConfirmAndClose = () => {
    handleConfirm();
    handleClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} aria-labelledby="dialog-title" fullWidth maxWidth="sm">
      <DialogTitle style={{ cursor: "move" }} id="dialog-title">
        {confirmTitle || "Are you sure?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{confirmQuestion}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {isCancelButton && (
          <Button autoFocus onClick={handleClose} color="primary">
            {cancelTitle || "Cancel"}
          </Button>
        )}
        <Button onClick={handleConfirmAndClose} color="primary">
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
